import { Box, Typography } from "@mui/material";
import { useLookupQuery } from "@sal/onevent-portal";
import dayjs from "dayjs";
import { useFormContext } from "react-hook-form";
import { FAFRate } from "../../models";

const currentDate = dayjs().format("YYYY-MM-DD HH:mm:ss");

export function EstimatedCharge() {
	const { watch } = useFormContext();
	const freightPayer = watch("freightPayer");
	const freightPayerID = freightPayer?.contactID;

	//BookedDate params Does not Exist on this context so use the current date
	const [fuelAdjustmentFactorLookup] = useLookupQuery<FAFRate>({
		systemName: "BLL_FuelAdjustmentFactor",
		additionalFilter: {
			customerID: freightPayerID ? freightPayerID : undefined,
			bookedDate: currentDate
		}
	});

	const fafRate = fuelAdjustmentFactorLookup?.data?.data?.results?.[0]?.additionalData?.fafRate
		? Number((fuelAdjustmentFactorLookup.data.data.results[0].additionalData.fafRate * 100).toFixed(2))
		: "";

	return (
		<Box sx={{ textAlign: "right", padding: "16px" }}>
			<Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
				Estimated Charge (NZD)
			</Typography>
			<Typography variant="h6" sx={{ fontWeight: "bold", color: "#000" }}>
				XXXX
			</Typography>
			<Typography variant="caption" display="block" sx={{ marginTop: "8px" }}>
				*Estimate excl GST, FAF & Surcharges
			</Typography>
			<Typography variant="body2" sx={{ marginTop: "8px" }}>
				FAF%&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				{fafRate}
			</Typography>
		</Box>
	);
}
